document.addEventListener('DOMContentLoaded', function() {
  document
    .querySelectorAll('.button-flavour-scroll')
    .forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const targetId = btn.getAttribute('href').slice(1);
        const target   = document.getElementById(targetId);

        if (!target) return;

        const rect         = target.getBoundingClientRect();
        const scrollTop    = window.pageYOffset || document.documentElement.scrollTop;
        const elementTop   = rect.top + scrollTop;
        const elementHeight = rect.height;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        let offset = ((viewportHeight - elementHeight) / 2);

        if (viewportWidth <= 800) {
          offset = ((viewportHeight - elementHeight) / 2) + 150;
        }

        window.scrollTo({
          top: elementTop - offset,
          behavior: 'smooth'
        });

      });
    });
});